import React from 'react'

import TmoButton from '../tmoButtons/TmoButton'
import withModal from './withModal'
import ConfirmationModalV2 from './ConfirmationModalV2'

import style from './ConfirmationButton.module.css'

function ConfirmationButton({
  className,
  handleDeleteClicked,
  modalMessage,
  modalTitle,
  modalAcceptButtonText,
  buttonIcon,
  buttonText,
  openModal,
  buttonType,
  tooltip,
  tooltipPosition = 'bottom',
  type,
  testId
}) {
  const handleClick = async () => {
    const { isConfirmed } = await openModal()
    if (isConfirmed) {
      handleDeleteClicked()
    }
  }

  return (
    <React.Fragment>
      <TmoButton
        type={buttonType ? buttonType : 'secondary_danger'}
        onClick={handleClick}
        className={className}
        tooltip={tooltip}
        position={tooltipPosition}
        data-testid={testId}
        aria-label={buttonText}
      >
        <span className={style.icon}>{buttonIcon}</span>
        {buttonText}
      </TmoButton>
      <ConfirmationModalV2
        type='danger'
        usePortal={false}
        message={modalMessage}
        title={modalTitle}
        acceptButtonText={modalAcceptButtonText}
        confirmInput
        modalType={type}
        testId={'modalId'}
      />
    </React.Fragment>
  )
}

export default withModal(ConfirmationButton)
